import { Component, OnInit } from '@angular/core';
import { NavController,IonRouterOutlet } from '@ionic/angular';
import { GlobalVars } from '../../../../../providers/globalVars';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
@Component({
  selector: 'app-initrate',
  templateUrl: './initrate.page.html',
  styleUrls: ['./initrate.page.scss'],
})
export class InitratePage implements OnInit {
  exchangerate: number;// = 814.0788;
  aud: any;
  krw: any;
  exrate: number;
  vfdone:boolean=true;
  cangoback:boolean = false;
  uid:any;
  name:any;
  constructor(private navCtrl:NavController,private outlet: IonRouterOutlet,private gv: GlobalVars
  ,private afDB: AngularFireDatabase,private afAuth: AngularFireAuth) { }

  close(){
    if(this.cangoback) this.navCtrl.pop()
    else this.navCtrl.navigateBack('/'); 
  }
  
  ngOnInit() {
    this.cangoback = this.outlet && this.outlet.canGoBack();
    this.initRate();
    if(this.gv.uid){
      this.uid = this.gv.uid;
      this.getdata();
    }
    else
      this.close();
  }

  getdata(){
    this.afDB.database.ref('/servicelist/forex/' + this.uid + '/userdata').once('value').then(data=>{
      if(data.val())
      {
        if(data.val().identified)
        {
          this.vfdone = true;
          this.name = data.val().name;
        }
        
      }
      else
        this.vfdone = false;
    })
  }

  initRate() {
    if(this.gv.holdingrate)
    this.exchangerate = Number(this.gv.holdingrate.toFixed(2));
    console.log((new Date().getTime() - this.gv.holdingtime));
//    console.log(this.gv.holdingtime);
  }

  isNumberKey(evt){
    const keycode = (evt.which) ? evt.which : evt.keyCode;
    //console.log(evt.path[1].nativeElement);
    if (
      (keycode >= 48 && keycode <= 57) || 
      (keycode >= 96 && keycode <= 105)
      ) {
      //console.log("number : " + keycode);
    } else if (
      keycode == 9 ||
      keycode == 8 ||
      keycode == 190 ||
      (keycode >= 37 && keycode <= 40)
    ) {
      //console.log("tab / delete / dot / arrows");
    } else if (
      keycode == 13
    ) {
      //console.log("enter");
    } else {
      evt.preventDefault();
      //console.log("not a number ... " + keycode );
    }
  }

  addCommas(event) {
    if( event.target.value.indexOf(',') < 1 ) {
      if( event.target.id == 'WON' ) {
        this.krw = event.target.value;
        this.krw = Number(this.krw);
        this.krw = this.krw.toLocaleString();
        return this.krw;
      } else if( event.target.id == 'AUD' ){
        this.aud = event.target.value;
        this.aud = Number(this.aud);
        this.aud = this.aud.toLocaleString();
        return this.aud;
      }
    }
  }

  removeCommas(num) {
    return num.replace(/,/g, '');
  }


  getkrw(event) {
    this.aud = event.target.value;
    this.aud = this.removeCommas(this.aud);
    
    this.krw = this.aud * this.exchangerate;
    this.krw = this.krw.toFixed(2);

    this.krw = Number(this.krw);
    this.krw = this.krw.toLocaleString();
  }

  getaud(event) {
    this.krw = event.target.value;
    this.krw = this.removeCommas(this.krw);

    this.aud = this.krw / this.exchangerate;
    this.aud = this.aud.toFixed(2);
    
    this.aud = Number(this.aud);
    this.aud = this.aud.toLocaleString();
  }

  removeChar(event) {
    event = event || window.event;
    var keyID = (event.which) ? event.which : event.keyCode;
    //console.log(event.target.value.replace(/[^0-9]/g, ""));
    if (keyID == 8 || keyID == 46 || keyID == 37 || keyID == 39)
      {
        return;
      }
    else
      {
        event.target.value = event.target.value.replace(/[^0-9\.]/g, "");
      }
  }
}
